import React, { useState } from "react";
import CreateProject from "./CreateProject";
import CreateProjectTwo from "./CreateProjectTwo";
import CreateProjectThree from "./CreateProjectThree";

const NewProjectCreateLayout = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [body, setBody] = useState({});

  const handleNextStep = () => {
    if (currentStep === 0) {
      return setCurrentStep((prev) => prev + 1);
    } else if (currentStep === 1) {
      return setCurrentStep((prev) => prev + 1);
    }
  };

  const steps = [
    <CreateProject next={handleNextStep} setBody={setBody} />,
    <CreateProjectTwo body={body} setBody={setBody} next={handleNextStep} />,
    <CreateProjectThree body={body} />,
  ];

  return steps[currentStep];
};

export default NewProjectCreateLayout;
